import classNames from "utils/class-names";
import { FILTER_TYPE } from "utils/constants";
import generatedFormatDate from "utils/generatedDate";

export const COLUMNS_DATA = () => [
  {
    Header: "S.No",
    accessor: "_index",
    disableSortBy: true,
  },
  {
    Header: "Appointment ID",
    accessor: "appointment_id",
    disableSortBy: true,
  },
  {
    Header: "Barcode No",
    accessor: "barcode_no",
    disableSortBy: true,
  },
  {
    Header: "Patient Name",
    accessor: "patient_name",
    disableSortBy: true,
  },
  {
    Header: "Age",
    accessor: "patient_age",
    disableSortBy: true,
    Cell: ({ value }) => {
      if (!value) return "-";
      const parts = [];
      if (value.year) parts.push(`${value.year}Y`);
      if (value.month) parts.push(`${value.month}M`);
      if (value.days) parts.push(`${value.days}D`);
      return parts.length ? parts.join(" ") : "-";
    },
  },
  {
    Header: "Franchise Name",
    accessor: "franchise_name",
    disableSortBy: true,
  },
  {
    Header: "Franchise Code",
    accessor: "franchise_code",
    disableSortBy: true,
  },
  {
    Header: "Investigation",
    accessor: "investigation_name",
    disableSortBy: true,
  },
  {
    Header: "Department",
    accessor: "department_name",
    disableSortBy: true,
  },
  {
    Header: "Sample Collection Date",
    accessor: "sample_collection_date",
    disableSortBy: true,
    Cell: ({ value }) => generatedFormatDate(value),
  },
  {
    Header: "Sample Receive Date",
    accessor: "sample_receive_date",
    disableSortBy: true,
    Cell: ({ value }) => generatedFormatDate(value),
  },
  {
    Header: "Result Entered Date",
    accessor: "result_entered_date",
    disableSortBy: true,
    Cell: ({ value }) => generatedFormatDate(value),
  },
  {
    Header: "Result Entered By",
    accessor: "result_entered_by_name",
    disableSortBy: true,
  },
  {
    Header: "Approved Date",
    accessor: "approved_date",
    disableSortBy: true,
    Cell: ({ value }) => generatedFormatDate(value),
  },
  {
    Header: "Approved By",
    accessor: "approved_by_name",
    disableSortBy: true,
  },
  {
    Header: "Delivery Time",
    accessor: "delivery_time",
    disableSortBy: true,
    Cell: ({ value }) => generatedFormatDate(value),
  },
  {
    Header: "Actual TAT",
    accessor: "actual_tat",
    disableSortBy: true,
  },
  {
    Header: "Deviation",
    accessor: "deviation",
    disableSortBy: true,
  },
];

export const BRANCH_FORM_CONFIG = (rowData) => [
  {
    label: "Branch",
    type: "input-text",
    name: "branch",
    defaultValue: rowData?.branch || "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Branch Address",
    type: "input-text",
    name: "branch_address",
    defaultValue: rowData?.branch_address || "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "City",
    type: "select",
    name: "city",
    defaultValue: rowData?.city || "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "State",
    type: "select",
    name: "state",
    defaultValue: rowData?.state || "",
    options: [],
    validations: {
      required: true,
    },
  },
  {
    label: "PinCode",
    type: "input-text",
    name: "pincode",
    defaultValue: rowData?.pincode || "",
    validations: {
      maxLength: 6,
      required: true,
      pattern: {
        value: /^[0-9]+$/,
        message: "Please enter a valid PinCode",
      },
    },
  },
  {
    label: "Area Name",
    type: "input-text",
    name: "area_name",
    defaultValue: rowData?.area_name || "",
    validations: {
      maxLength: 255,
      required: true,
    },
  },
  {
    label: "Zone",
    type: "select",
    name: "zone_id",
    defaultValue: rowData?.zone_name || "",
    options: [],
    validations: {
      required: true,
    },
  },
];

export const OPTIONS = [
  { key: "branch", value: "Branch" },
  { key: "state", value: "State" },
  { key: "city", value: "City" },
  { key: "area_name", value: "Area Name" },
  { key: "branch_address", value: "Address" },
  { key: "zone_name", value: "Zone" },
];
export const STATUS_OPTIONS = [
  { key: true, value: "Active" },
  { key: false, value: "In-Active" },
];
export const FILTER_DEFINATIONS = [
  {
    name: "keyword",
    type: FILTER_TYPE.SELECT,
    initialValue: OPTIONS[0].key,
  },
  {
    name: "text",
    type: FILTER_TYPE.TEXT,
    initialValue: "",
    debounce: true,
  },
  {
    name: "is_active",
    type: FILTER_TYPE.SELECT,
    initialValue: STATUS_OPTIONS[0].key,
  },
];
